import { defineComponent, h } from 'vue';
import { ConfirmationModal } from '@/ui/components/modals/ConfirmationModal';
import { t } from '@/ui/i18n/i18n';

interface ResetKeyConfirmationModalProps {
  active: boolean;
  loading: boolean;
}

export const ResetKeyConfirmationModal = defineComponent<ResetKeyConfirmationModalProps>({
  name: 'ResetKeyConfirmationModal',
  props: ['active', 'loading'],
  setup(props, context) {
    const onCancelClick = () => {
      context.emit('input', false);
    };

    const onConfirmation = () => {
      context.emit('click:resetKeys');
    };

    return function render() {
      return h(ConfirmationModal, {
        class: 'reset-key-confirmation-modal',
        props: {
          width: '580px',
          active: props.active,
          confirmText: t('api-keys.reset-key.confirmation'),
          declineText: t('common.cancel'),
          confirmationButtonProps: { type: 'is-danger', loading: props.loading },
        },
        on: {
          declined: onCancelClick,
          accepted: onConfirmation,
        },
      }, [
        h('h1', { class: 'reset-key-confirmation-modal__title title' }, t('api-keys.reset-key.title')),
        h('div', t('api-keys.reset-key.description')),
      ]);
    };
  },
});
